import { render, staticRenderFns } from "./SmartDocSidebar.vue?vue&type=template&id=6a000c58&"
import script from "./SmartDocSidebar.vue?vue&type=script&lang=js&"
export * from "./SmartDocSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports